// removed by extract-text-webpack-plugin
module.exports = {"headLine":"_3ZZZB4oD6MLlaqXW2669lO","info":"_3tsRhRpFVbaLK5HY37HXIv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/MyPlaylist.scss
// module id = 1353
// module chunks = 1